import { AutoMap } from "@automapper/classes";
import { PointagePauseDTO } from "./pointage-pause.dto";

export class PointageJournalierDTO {
    @AutoMap()
    departDomicile?: string;
    @AutoMap()
    debutJournee!: string;
    @AutoMap()
    finJournee!: string;
    @AutoMap()
    arriveeDomicile?: string;
    @AutoMap(() => [PointagePauseDTO])
    pointagePauseList: PointagePauseDTO[] = [];
}